import { render, staticRenderFns } from "./CommissionWithdrawal.vue?vue&type=template&id=452c0a53&scoped=true&"
import script from "./CommissionWithdrawal.vue?vue&type=script&lang=js&"
export * from "./CommissionWithdrawal.vue?vue&type=script&lang=js&"
import style0 from "./CommissionWithdrawal.vue?vue&type=style&index=0&id=452c0a53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452c0a53",
  null
  
)

export default component.exports